import { Union } from 'ts-toolbelt';

import {
  NegotiationCaseDetailQuoteQuery,
  TsrctCaseCancellationReason,
  TsrctIssueVariant,
  TsrctNegotiationCaseStatus,
  TsrctSupplierInteractionMode,
} from '@/generated/gql/graphql';

export const manualReviewStatus: TsrctNegotiationCaseStatus[] = [TsrctNegotiationCaseStatus.MANUAL_NEGOTIATION];
export const noAgreementStatus: TsrctNegotiationCaseStatus[] = [TsrctNegotiationCaseStatus.NO_AGREEMENT_REACHED];
export const agreementStatus: TsrctNegotiationCaseStatus[] = [
  TsrctNegotiationCaseStatus.AGREEMENT_REACHED,
  TsrctNegotiationCaseStatus.AGREEMENT_CONFIRMED,
  TsrctNegotiationCaseStatus.AWARDED,
];

export const cancelledStatus: TsrctNegotiationCaseStatus[] = [
  TsrctNegotiationCaseStatus.CANCELLED_AFTER_INVITE_EMAIL_SENT,
  TsrctNegotiationCaseStatus.CANCELLED_BEFORE_INVITE_EMAIL_SENT,
];

export const combinedStatus: TsrctNegotiationCaseStatus[] = [
  ...manualReviewStatus,
  ...noAgreementStatus,
  ...agreementStatus,
  ...cancelledStatus,
];

export type DetailStatusProps = {
  negotiationCaseStatus: TsrctNegotiationCaseStatus;
  negotiatedQuote: NegotiationCaseDetailQuoteQuery['tesseract']['negotiationCase']['negotiatedQuote'];
  supplierInteractionMode?: Union.Nullable<TsrctSupplierInteractionMode>;
  isMasked?: boolean;
  cancellationReason?: Union.Nullable<TsrctCaseCancellationReason>;
  cancellationReasonText?: Union.Nullable<string>;
};

export const commentEnabledModes = [
  TsrctSupplierInteractionMode.COMMENT_ENABLED,
  TsrctSupplierInteractionMode.FINAL_OFFER_ENABLED,
];

export const retriableIssueVariants = [
  TsrctIssueVariant.CONTRACT_CREATE_FAILED,
  TsrctIssueVariant.CONTRACT_UPDATE_FAILED,
  TsrctIssueVariant.PURCHASE_ORDER_CREATE_FAILED,
  TsrctIssueVariant.PURCHASE_ORDER_UPDATE_FAILED,
  TsrctIssueVariant.PURCHASE_REQUISITION_CREATE_FAILED,
  TsrctIssueVariant.PURCHASE_REQUISITION_UPDATE_FAILED,
];
